import { ActivitiesSingleProperties } from 'apps/web/enums/pageKey';

import ACTIVITIES_FORM_KEYS from './formKeys';

const ACTIVITIES_CONTENT_MAPPER_KEYS = {
  local: [
    {
      key: ActivitiesSingleProperties.subject,
      value: ACTIVITIES_FORM_KEYS.subject,
    },
    {
      key: ActivitiesSingleProperties.gradeLevel,
      value: ACTIVITIES_FORM_KEYS.gradeLevel,
    },
    {
      key: ActivitiesSingleProperties.objective,
      value: ACTIVITIES_FORM_KEYS.objective,
    },
    {
      key: ActivitiesSingleProperties.difficulty,
      value: ACTIVITIES_FORM_KEYS.difficulty,
    },
    {
      key: ActivitiesSingleProperties.materials,
      value: ACTIVITIES_FORM_KEYS.materials,
    },
    {
      key: ActivitiesSingleProperties.time,
      value: ACTIVITIES_FORM_KEYS.time,
    },
    {
      key: ActivitiesSingleProperties.language,
      value: ACTIVITIES_FORM_KEYS.language,
    },
  ],
  american: [
    {
      key: ActivitiesSingleProperties.curriculumFramework,
      value: ACTIVITIES_FORM_KEYS.curriculumFramework,
    },
    {
      key: ActivitiesSingleProperties.gradeLevel,
      value: ACTIVITIES_FORM_KEYS.gradeLevel,
    },
    {
      key: ActivitiesSingleProperties.subject,
      value: ACTIVITIES_FORM_KEYS.subject,
    },
    {
      key: ActivitiesSingleProperties.specificStandards,
      value: ACTIVITIES_FORM_KEYS.specificStandards,
    },
    {
      key: ActivitiesSingleProperties.objective,
      value: ACTIVITIES_FORM_KEYS.objective,
    },

    {
      key: ActivitiesSingleProperties.strategies,
      value: ACTIVITIES_FORM_KEYS.strategies,
    },
    {
      key: ActivitiesSingleProperties.difficulty,
      value: ACTIVITIES_FORM_KEYS.difficulty,
    },
    {
      key: ActivitiesSingleProperties.materials,
      value: ACTIVITIES_FORM_KEYS.materials,
    },
    {
      key: ActivitiesSingleProperties.time,
      value: ACTIVITIES_FORM_KEYS.time,
    },
  ],
};

export default ACTIVITIES_CONTENT_MAPPER_KEYS;
